module.exports = __webpack_public_path__ + "assets/img/img_prasia@2x.dc15acde.png";